/**
 * Get all data values under a specific data namespace.
 *
 * Options:
 *
 * excludePrefix - (bool) Returns data array with prefix excluded
 *
 * Example:
 *
 *   <a data-sw-param1 data-sw-param2 data-sw-param1-more-specific="value" href="">Click</a>
 *
 *   $('[data-sw-param1]').swDataParams('swParam1') => { swParam1: null, swParam1MoreSpecific: 'value' }
 *
 */

var _ = require('underscore');

module.exports = function($) {

  $.fn.swDataParams = function(prefix, options) {
    options = options || {};
    var $el = $(this);

    // Because jQuery!!!! busting the .data() cache for prefixes we care about
    var initialData = $el.data();

    var prefixNames = Object.keys(initialData).filter(function(key){
      return key.substr(0, prefix.length) === prefix;
    });

    var data = $el.removeData(prefixNames)[0].dataset;

    var params = {};
    
    params[prefix] = $el.data(prefix);

    _.each(data, function(value, key) {
      if (key.indexOf(prefix) === 0) {

        var newKey = key;
        if (options.excludePrefix) {
          newKey = newKey.replace(prefix, '');

          // lowercase first letter
          if (newKey.length <= 1) {
            newKey = newKey.toLowerCase();
          } else {
            newKey = newKey.substring(0, 1).toLowerCase() + newKey.substring(1);
          }
        }

        if (newKey.length) {
          params[newKey] = $el.data(key);
        }
      }
    });

    return params;
  };

};
